import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { AppService } from '@core/services/app.service';
import { environment } from '@root/environments/environment';

const HTTP_METHODS_TO_SHOW_LOADER = ['POST', 'GET'];
const ACCESS_TOKEN_PATH = 'AccessControl/Token';

const EXCLUDED_PATHS = [ACCESS_TOKEN_PATH];
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private activeRequests = 0;
  private readonly appService = inject(AppService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const isTargetRequest =
      this.isAllowedMethod(req) && this.isAllowedPath(req.url);

    if (!isTargetRequest) {
      return next.handle(req); // Ignore other requests
    }

    this.activeRequests++;
    this.appService.isLoading.next(true);

    return next.handle(req).pipe(
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests === 0) {
          this.appService.isLoading.next(false);
        }
      })
    );
  }

  private isAllowedPath(url: string): boolean {
    const isUrlExcluded =
      EXCLUDED_PATHS.filter((path) => url.includes(path)).length > 0;

    return url.startsWith(environment.apiUrl) && !isUrlExcluded;
  }

  private isAllowedMethod(req: HttpRequest<unknown>) {
    return HTTP_METHODS_TO_SHOW_LOADER.some((method) => req.method == method);
  }
}
